import Input from "components/EvtKit/input/Input"
import { memo, useCallback } from "react"
import styled from "styled-components"

import IconInformative from "components/EvtKit/icons/IconInformative"
import SwitchV2 from "components/EvtKit/switch/SwitchV2"
import Tooltip from "components/Tooltip"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 28px;
  margin-bottom: 4px;
`

const CheckboxContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ProductInfoContainer = styled.div`
  display: grid;
  justify-items: center;
  width: 100%;
`

const ContainerInput = styled.div`
  width: 100%;
`

const ContainerModal = styled.div`
  display: grid;
  width: 100%;
`

const MiniContainers = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 24px;
  gap: 28px;
`

const IconContainer = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -5px;
  cursor: pointer;
  & span {
    top: -208px;
    width: 268px;
    text-align: left;
  }

  &.switch {
    right: -16px;
  }
`

const RefreshIcon = styled.div`
  position: absolute;
  padding-left: 208px;
  transform: translateY(-50%);
  z-index: 2;
  font-size: 24px;
  color: ${(props) => props.theme.palette.subtitle};
  cursor: pointer;
  user-select: none;
`

interface Props {
  isFederated: boolean
  setIsFederated: React.Dispatch<React.SetStateAction<boolean>>
  productInfo: App.ProductInfo
  setProductInfo: React.Dispatch<React.SetStateAction<App.ProductInfo>>
}

const IsFederated = (props: Props) => {
  const { isFederated, setIsFederated, productInfo, setProductInfo } = props

  const handleCheckboxChange = useCallback(() => {
    setIsFederated((prevIsFederated: boolean) => !prevIsFederated)
  }, [isFederated, setIsFederated])

  const handleProductInfoInputsChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { id, value } = e.target

      setProductInfo((prevProductInfo) => ({
        ...prevProductInfo,
        [id]: value
      }))
    },
    [setProductInfo]
  )

  return (
    <Container>
      <CheckboxContainer>
        <CheckboxContent>
          <SwitchV2 label="Produto Federado" value={isFederated} onChange={handleCheckboxChange} />
          <RefreshIcon id="federated">
            <IconContainer className="switch">
              <Tooltip text=" Permite a interação com outro backend, que vai utilizar capacidades de autenticação e acessar informações armazenadas no Shelf para o funcionamento. Por exemplo, produtos/serviços que envolvem um portal externo e se deseja controlar funcionalidades nesse portal utilizando o Shelf como SSO e controle de cobrança.">
                <IconInformative />
              </Tooltip>
            </IconContainer>
          </RefreshIcon>
        </CheckboxContent>
      </CheckboxContainer>
      <ContainerModal>
        <div>
          <MiniContainers>
            <ProductInfoContainer>
              <ContainerInput>
                <Input
                  id="federationUrl"
                  type="text"
                  name="urlProduto"
                  label="URL do Produto *"
                  className="fullWidth"
                  value={productInfo.federationUrl}
                  onChange={handleProductInfoInputsChange}
                  disabled={!isFederated}
                  placeholder="Digite"
                  shrink
                />
              </ContainerInput>
            </ProductInfoContainer>
          </MiniContainers>
        </div>
      </ContainerModal>
    </Container>
  )
}

export default memo(IsFederated)
